import Callout from "../UI/Callout";
import Signature from "./Signature";
import Logo from "./Logo";
import Smtp from "./Smtp";
import MailSignature from "./MailSignature";
import MailTemplatesList from "./MailTemplatesList";
// @ts-expect-error pure js
import useCustomization from "../../hooks/use-customization";
import styles from "./Parametres.module.css";

export default function Parametres() {
  const {
    customization,
    createOrUpdateCustomization,
    resetCustomization,
    testSmtp,
  } = useCustomization();

  return (
    <div className={styles.wrapper}>
      <Callout variant="info">
        Ces paramètres s'appliquent par défaut à tous vos profils bailleurs.
        Pour en personnaliser un en particulier, rendez-vous dans l'onglet
        Paramètres du profil concerné.
      </Callout>
      <div className={styles.grid}>
        <Signature
          customization={customization}
          onSave={createOrUpdateCustomization}
          onReset={resetCustomization}
        />
        <Logo
          customization={customization}
          onSave={createOrUpdateCustomization}
          onReset={resetCustomization}
        />
        <Smtp
          onSave={createOrUpdateCustomization}
          onReset={resetCustomization}
          onTest={testSmtp}
          customization={customization}
        />
        <MailSignature
          customization={customization}
          onSave={createOrUpdateCustomization}
          onReset={resetCustomization}
        />
      </div>
      <MailTemplatesList />
    </div>
  );
}
